import type { PropsWithChildren, ReactNode } from 'react';

import css from './styles.module.css';

/**
 *	A lead paragraph — the `% …` paragraph. Rendered from the paragraph node
 *	override in @shared/docs/markdoc, never written by hand.
 */
export function Ingress({ children }: PropsWithChildren): ReactNode {
	return <p className={css.ingress}>{children}</p>;
}
